/* Source: /app/hooks/useMobile.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
let MOBILE_BREAKPOINT = 768;
let TABLET_BREAKPOINT = 1024;
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    function checkMobile() {
      setIsMobile((window.innerWidth < MOBILE_BREAKPOINT));
    }
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);
  return isMobile;
}
function useIsTablet() {
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    function checkTablet() {
      let width = window.innerWidth;
      setIsTablet(((width >= MOBILE_BREAKPOINT) && (width < TABLET_BREAKPOINT)));
    }
    checkTablet();
    window.addEventListener("resize", checkTablet);
    return () => {
      window.removeEventListener("resize", checkTablet);
    };
  }, []);
  return isTablet;
}
function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(true);
  useEffect(() => {
    function checkDesktop() {
      setIsDesktop((window.innerWidth >= TABLET_BREAKPOINT));
    }
    checkDesktop();
    window.addEventListener("resize", checkDesktop);
    return () => {
      window.removeEventListener("resize", checkDesktop);
    };
  }, []);
  return isDesktop;
}
function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState("desktop");
  useEffect(() => {
    function checkBreakpoint() {
      let width = window.innerWidth;
      if ((width < MOBILE_BREAKPOINT)) {
        setBreakpoint("mobile");
      } else if ((width < TABLET_BREAKPOINT)) {
        setBreakpoint("tablet");
      } else {
        setBreakpoint("desktop");
      }
    }
    checkBreakpoint();
    window.addEventListener("resize", checkBreakpoint);
    return () => {
      window.removeEventListener("resize", checkBreakpoint);
    };
  }, []);
  return breakpoint;
}
export {useBreakpoint, useIsDesktop, useIsMobile, useIsTablet};